import React, { FC } from "react";
import styled from "styled-components";
import {
  FontSize,
  FontStyle, FontWeight, Color, theme
} from "../config/theme";

const StyledLink = styled.a<LinkProps>`
  display:         inline-block;
  font-weight:     normal;
  position:        relative;
  text-decoration: none;
  cursor:          pointer;
  font-size:   ${(p) => p.size ? `${theme.font.size[p.size]}` : `${theme.font.size.default}`};
  font-weight: ${(p) => `${theme.font.weight[p.weight]}`};
  font-style:  ${(p) => `${theme.font.style[p.fontStyle]}`};
  color:       ${(p) => p.color in theme.color ? `${theme.color[p.color as Color]}` : p.color || `${theme.font.color.black}`};

  :visited {
    opacity: 0.9;
  }

  :hover {
    text-decoration: underline;
  }
`;

type LinkProps = {
  color?:     Color | string;
  fontStyle?: FontStyle;
  href?:      string;
  onClick?:   (e?: any) => void;
  size?:      FontSize;
  text?:      string;
  weight?:    FontWeight;
  children?:  React.ReactNode;
};

export const Link: FC<LinkProps> = ({
  text,
  onClick,
  size = "small",
  children,
  ...props
}) => {
  
  const handleClick = (e: any) => {
    e.preventDefault();
    if (onClick) {
      onClick();
      return;
    }
  };

  return (
    <StyledLink size={size} onClick={handleClick} {...props}>
      {text}
      {React.Children.map(children, (child) => child)}
    </StyledLink>
  );
};
